import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import PrintableContent from './PrintableContent';

export default function Test() {
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        contentRef: componentRef, // ✅ required in JS
        documentTitle: 'KingGreeting',
    });

    return (
        <div>
            <button onClick={handlePrint}>Print</button>
            <div ref={componentRef}>
                ksfbvkjxbfv
                fvlnfdvjklfv
                dflnvdlj
                v
            </div>
        </div>
    );
}
